import OrganizationEmailIdentityCreateModal from "./OrganizationEmailIdentityCreateModal"

export default OrganizationEmailIdentityCreateModal
